import {ErrorProcessor, LOAD_ERROR_MSG, ProcessingError} from '../types'
import {getLoadErrorSrc, updateAdditional} from '../utils'

const deprioritizeOptions: Partial<ProcessingError> = {
  message: `CHUNK ${LOAD_ERROR_MSG._}`,
  level: Ya.Rum.ERROR_LEVEL.INFO,
}

const chunkFailedMessageRE = new RegExp('Loading( CSS)? chunk(.*?)failed.(.|\n)\\(')

const chunkNameFromMessage = (message: ProcessingError['message']) => message.match(/\(([^)]+)\)/)![1]

export const processChunkTimeouts: ErrorProcessor = (error, scope) => {
  if (chunkFailedMessageRE.test(error.message)) {
    const params = chunkNameFromMessage(error.message)!.split(': ').reverse()

    updateAdditional(error, 'src', params[0]!)
    updateAdditional(error, 'reason', params[1] || 'unknown')

    return scope.updateError(deprioritizeOptions)
  }

  if (
    [LOAD_ERROR_MSG.SCRIPT, LOAD_ERROR_MSG.LINK].includes(error.message) &&
    getLoadErrorSrc(error)?.includes('.chunk.')
  ) {
    return scope.updateError(deprioritizeOptions)
  }

  return error
}
